import { Component, OnInit } from '@angular/core';
import { loadingFade, modal, alert } from '../../animacoes';
import { FormBuilder, FormGroup } from '@angular/forms';

import { AlertaService } from '../services/alerta.service';
import { AuthService } from '../services/auth.service';

@Component({
	selector: 'app-alertas',
	templateUrl: './alertas.component.html',
	styleUrls: ['./alertas.component.css'],
	animations: [loadingFade, modal, alert]
})
export class AlertasComponent implements OnInit {
	public loading = false;
	public alertas = [];
	public formFiltro: FormGroup;

	// paginacao
	public page = 1;
	public limit = 10;
	public count = 0;

	// modal
	public modalFinalizar = 'hidden';
	public idAlertaFinalizar = null;
	public modificado = []; // se finalizar um alerta, insere aqui; para atualizar o botao sem ter q recarregar a lista

	// alert
	public msg_alerta = '';
	public class_alerta = '';
	public flag_alerta = 'hidden';

	// filtro
	public filtro = [];

	constructor(private fb: FormBuilder,
				private alertaSvc: AlertaService,
				private authSvc: AuthService,
				) { }

	ngOnInit() {
		this.pegaAlertas();
	}
 
	pegaAlertas() {
		this.alertas = [];
		this.loading = true;
		this.alertaSvc.getAlertas(this.authSvc.getUsuarioId()).then((data: any[]) => {
			this.alertas = data;
			this.count = this.alertas.length;
			this.loading = false;
		}).catch((err) => {
			console.log(err);
			this.loading = false;
		});
	}

	primPagina() {
		this.page = 1;
	}

	paginaAnt() {
		this.page = Math.max(this.page - 1, 1);
	}

	proxPagina() {
		this.page = Math.min(this.page + 1, Math.ceil(this.count / this.limit));
	}

	ultPagina() {
		this.page = Math.ceil(this.count / this.limit);
	}

	perguntaFinalizar(id) {
		this.modalFinalizar = 'shown';
		this.idAlertaFinalizar = id;
	}

	cancelaFinalizar() {
		this.modalFinalizar = 'hidden';
	}

	finalizaAlerta() {
		this.modalFinalizar = 'hidden';
		this.loading = true;
		this.alertaSvc.finalizaAlerta(this.idAlertaFinalizar).then((data) => {
			this.mostraMsg('Alerta finalizado com sucesso.', 'alert-success');
			this.modificado[this.idAlertaFinalizar] = true;
			this.loading = false;
		}).catch((err) => {
			console.log(err);
			this.mostraMsg('Problema ao finalizar alerta.', 'alert-danger');
			this.loading = false;
		});
	}

	mostraMsg(msg, classe) {
		this.msg_alerta = msg;
		this.class_alerta = classe;
		this.flag_alerta = 'shown';
		setTimeout(() => this.flag_alerta = 'hidden', 10);
	}
}
